import { useAnalytics } from "@hooks/useAnalytics";
import { type ComponentProps, type GatsbyCustomImage } from "@ts/components";
import { type ProductVideo } from "@ts/sanity";
import React, { useCallback, type FC } from "react";

type VideoProps = ComponentProps & {
  video?: Partial<ProductVideo>;
  videoBackground?: GatsbyCustomImage;
  playing?: boolean;
};

export const withVideo =
  (Component: FC<VideoProps>) =>
  ({ name = "Video", analytics = {}, muted = true, ...props }: VideoProps) => {
    const { trackPromoImpression, VisibilitySensor } = useAnalytics();

    const handleVisibiltyChange = useCallback(
      (visible: boolean) => {
        if (!visible) return;
        trackPromoImpression({ ...analytics });
      },
      [trackPromoImpression, analytics],
    );

    Component.displayName = name;
    return (
      <VisibilitySensor onChange={handleVisibiltyChange}>
        <Component {...props} muted={muted} />
      </VisibilitySensor>
    );
  };
